import React from 'react'
import { Icon } from 'components/library'
import './Tips.css'

const Tips = props => (
  <div className="Tips">
    <div className="Tips-icon"><Icon name={props.icon} size="large" /></div>
    {props.children}
  </div>
)

export default Tips


// WEBPACK FOOTER //
// ./src/components/library/tips/Tips.js